import { render } from "./more-vert.svg?vue&type=template&id=bfd73a54"
import script from "./more-vert.svg?vue&type=script&lang=js"
export * from "./more-vert.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src844/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__